import { OptionType } from '@evinced-private/ui-common';

import { naturalSort } from 'src/common/helpers/DataFilterHelper';
import { ILabelConfig } from 'src/common/types/LabelsTypes';

export const createSortedOptions = (valuesSet: Set<string>): OptionType[] => {
	return Array.from(valuesSet)
		.sort(naturalSort)
		.map((value) => ({
			value,
			label: value
		}));
};

export const transformLabels = (
	customFields: string[][],
	appLabels: string[] = [],
	appVersionLabels: string[] = [],
	labelsConfig?: ILabelConfig[]
): string[] => {
	const combinedAppLabels = [...appLabels, ...appVersionLabels.filter(Boolean)];

	if (!customFields?.length) {
		return combinedAppLabels;
	}

	const labelMap = labelsConfig ? new Map(labelsConfig.map((label) => [label.key, label])) : null;

	const raw: string[] = [];
	const processed: string[] = [];

	for (const [labelKey, valueKey] of customFields) {
		if (!labelKey || !valueKey) {
			continue;
		}

		raw.push(`${labelKey}: ${valueKey}`);

		if (labelMap) {
			const label = labelMap.get(labelKey);
			const displayValue = label?.options?.find((opt) => opt.key === valueKey)?.name;
			if (displayValue) {
				processed.push(displayValue);
			}
		}
	}

	return [...combinedAppLabels, ...raw, ...processed];
};
